export class ProspectoModel {
  public idSocio: number;
  public idUsuario: number;
  public apellidoPat: string;
  public apellidoMat: string;
  public nombreCompleto: string;
  public genero: string;
  public correoElectronico: string;
  public telefonoMovil: string;

  constructor() {}
}
